const Questions = {
  intro: "Bevor wir spielen habe ich 5 Fragen über den Jungenaktionstag an Dich! Es wäre toll, wenn Du sie mir beantwortest!",
  questions: [{
    text: "Bist du gerne hier?",
    answers: ["Ja", "Nein"]
  }, {
    text: "Hast du Spaß?",
    answers: ["Ja", "Nein"]
  }, {
    text: "Weißt Du, dass Du dir beim Infopunkt Hilfe holen kannst?",
    answers: ["Ja", "Nein"],
    followUp: {
      "Nein": '<img class="survey-image" src="assets/gfx/shirt.png">Sprich jemand in diesem T-Shirt an. Die sind nett und werden dir helfen!'
    }
  }, {
    text: "Waren die Erwachsenen heute nett zu Dir?",
    answers: ["Ja", "Nein"],
    sub: {
      "Nein": {
        text: "Was ist passiert?",
        answers: ["Ich wurde von Erwachsenen beleidigt.", "Ich wurde von Erwachsenen angefasst.", "Etwas anderes."],
        followUp: '<img class="survey-image" src="assets/gfx/shirt.png">Wenn das doof war, kannst Du Dich am Infopunkt beschweren! Die Menschen helfen dir!'
      }
    }
  }, {
    text: "Waren alle Situationen heute angenehm für Dich?",
    answers: ["Ja", "Nein"],
    sub: {
      "Nein": {
        text: "Was ist passiert?",
        answers: ["Ich wurde von Kindern beleidigt.", "Ich wurde von Kindern angefasst.", "Essen schmeckte nicht.", "Ich musste zu lange warten.", "Ich konnte ein Angebot nicht machen."],
        followUp: '<img class="survey-image" src="assets/gfx/shirt.png">Wenn das doof war, kannst Du Dich am Infopunkt beschweren! Die Menschen helfen dir!'
      }
    }
  }],
  outro: "Danke für das Mitmachen.<br>Zur Erinnerung: Hilfe bekommst du beim Infopunkt.<br>Viel Spaß beim Spielen!"
};
export default Questions;